import { motion, useReducedMotion } from "framer-motion";
import { Cpu, ShieldCheck, UserCheck, ArrowRight } from "lucide-react";

const NODES = [
  { icon: Cpu, label: "AI", line: "recommends" },
  { icon: ShieldCheck, label: "POLICY", line: "governs" },
  { icon: UserCheck, label: "HUMANS", line: "remain accountable" },
];

const item = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};

export const GovernanceFlow = () => {
  const reduce = useReducedMotion();
  return (
    <div className="grid sm:grid-cols-[1fr_auto_1fr_auto_1fr] items-stretch gap-4 sm:gap-2">
      {NODES.map((n, i) => (
        <div key={n.label} className="contents">
          <motion.div
            {...item}
            transition={{ duration: reduce ? 0 : 0.9, delay: reduce ? 0 : i * 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl border border-[#161616] bg-[#0a0a0a] p-7 flex flex-col items-start"
          >
            <span className="h-11 w-11 rounded-full border border-cyan-400/25 bg-cyan-400/10 flex items-center justify-center mb-5">
              <n.icon className="h-5 w-5 text-cyan-400" strokeWidth={1.5} />
            </span>
            <div className="font-heading text-2xl text-white">{n.label}</div>
            <div className="mono-label text-zinc-500 mt-2">{n.line}</div>
          </motion.div>
          {i < NODES.length - 1 && (
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: reduce ? 0 : 0.6, delay: reduce ? 0 : i * 0.5 + 0.35 }}
              className="hidden sm:flex items-center justify-center px-2"
            >
              <ArrowRight className="h-6 w-6 text-cyan-400/70" />
            </motion.div>
          )}
        </div>
      ))}
    </div>
  );
};
